import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({ title, kicker, updated, children, testId }) {
  return (
    <div
      data-testid={testId}
      className="min-h-screen bg-[#F2EBDC] text-[#0A0A0A]"
    >
      <header className="bg-[#FF5B17] border-b-2 border-[#0A0A0A]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-8 h-14 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-home-link"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] hover:underline underline-offset-4"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to RTAMA
          </Link>
          <Link to="/" className="font-display text-2xl tracking-tight">
            R⋆TAMA
          </Link>
        </div>
      </header>

      <main className="max-w-[820px] mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF2D9C] mb-3">
          {kicker}
        </div>
        <h1
          className="font-display"
          style={{
            fontSize: "clamp(2.75rem, 9vw, 6.5rem)",
            lineHeight: 0.85,
            letterSpacing: "-0.025em",
          }}
        >
          {title}
        </h1>
        <div className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#0A0A0A]/60">
          last updated · {updated}
        </div>
        <div className="mt-4 flex gap-2">
          <span className="sticker bg-[#FFD500]">Cyprus, EU</span>
          <span className="sticker bg-[#00E5A0]">Worldwide service</span>
        </div>

        <div className="mt-12 zine-prose">{children}</div>

        <div className="mt-16 border-t-2 border-[#0A0A0A] pt-6 flex flex-wrap gap-3">
          <Link to="/privacy" className="sticker hover:bg-[#FFD500] transition-colors">Privacy</Link>
          <Link to="/terms" className="sticker hover:bg-[#FFD500] transition-colors">Terms</Link>
          <Link to="/cookies" className="sticker hover:bg-[#FFD500] transition-colors">Cookies</Link>
          <Link to="/" className="sticker ml-auto bg-[#FF2D9C] text-[#FAF5E8] border-[#0A0A0A]">← Home</Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
